import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../context/Theme.context';
import Loading from '../Loading';
import { Box } from '@otcmarketsgroup/otcm-ui-lib';

const Layout = ({ children }) => {
  const theme = useContext(ThemeContext);
  const lock = theme.state.lock;

  return <>
    {!!lock && <Box position="fixed" left="50%" top="50%" zIndex="999999">
      <Loading />
    </Box>}
    <Box display="relative">
      {lock && <Box position="absolute"
        width="100%"
        height="100%"
        background="var(--otc-white)"
        opacity=".25"
        zIndex="999" />}
      {children}
    </Box>
  </>;
};

Layout.propTypes = {
  children: PropTypes.node
};


export default Layout;
